/**
 * 计算表格序号
 * @param {*} index 原生序号 从0开始
 * @param {*} currentPage
 * @param {*} pageSize
 * @returns
 */
export const indexMethod = (index, currentPage, pageSize) => {
  return (currentPage - 1) * pageSize + index + 1
}
